import Vue from 'vue';

Vue.directive('click-outside', {
  bind(el, binding) {
    const handler = (e) => {
      if (!el.contains(e.target) && el !== e.target) {
        binding.value(e);
      }
    };
    el.out = handler;
    document.addEventListener('click', handler);
  },

  unbind(el) {
    document.removeEventListener('click', el.out);
    el.out = null;
  },
});
